import { useEffect } from 'react';

const BASE_TITLE = 'TMS Portal';

export function useDocumentTitle(title: string | undefined | null): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} — ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
